<template>
    <div class="gz-input-container">
        
        <Label 
            v-if="label"
            :label="label" 
            :labelClickable="labelClickable" 
            :required="required"
            @labelClick="$emit('label-сlick')"
        />
        
        <div class="gz-input__slot-container" @click.stop="show = !show">
            <!-- Text Input -->
            <slot></slot>
            <!-- End Text Input -->
            <div class="gz-input__control-icon" :class="{'gz-input__control-icon_active': show}">
                <span class="icon-chevron_right-24px"></span>
            </div>
        </div>

        <!-- Validation -->
        <ValidationMark 
            v-if="type !== 'filter'" 
            :valid="valid" 
            :validationMessage="validationMessage" 
            class="gz-input-container__validation_select"
        />
        
        <!-- Dropdown list -->
        <transition name="fade-quick" appear>
            <div class="gz-select__dropdown" v-if="showDropdown">
                <div
                    v-for="(item, index) in dropDownList"
                    :key="index" 
                    class="gz-select__item"
                    @click="selectItem(item)"
                ><span>{{ item.name }}</span></div>
            </div>
        </transition>
    </div>
</template>

<script>
import Label from './Label'
import ValidationMark from './BaseValidationMark'

export default {
    name: 'SelectContainer',

    props: {
        type: {
            //Фильтр или форма
            type: String,
            default: 'form'
        },
        label: {
            type: String
        },
        labelClickable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: true
        },
        validationMessage: {
            type: String,
            default: 'Обязательно для заполнения'
        },
        dataList: {
            //Список вариантов для выбора
            type: Array
        },
        defaultItem: {
            //Значение по умолчанию (все, ничего, любой и т.д.)
            type: Object,
            default: () => ({name: ' ', value: null})
        },
        defaultSelected: {
            //Порядковый номер выбранного значения поумолчанию
            type: Number,
            default: 0
        }
    },
    components: {
        ValidationMark,
        Label
    },
    data() {
        return {
            show: false,
            selectedItem: this.defaultItem ? this.defaultItem : '',
            list: []
        }
    },
    computed: {
        showDropdown() {
            return this.show
        },
        dropDownList() { 
            return this.list
        }
    },
    mounted() {
        document.addEventListener('click', () => {
            this.closeOnBlur()
        })

        //Добавляю данные к массиву с первым пустым значением
        this.dataList.forEach(item => {
            this.list.push(item)
        })

        if (this.defaultSelected) {
            //Если указанно значение, то устанавливаем его поумолчанию
            this.list.forEach((item, index) => {
                if (index + 1 === this.defaultSelected) {
                    this.selectItem(item)
                }
            })
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', () => {
            this.closeOnBlur()
        })
    },
    methods: {
        closeOnBlur() {
            const target = event.target
            
            if (!target.classList.contains('gz-select__dropdown')) {
                this.show = false
            }
        },
        selectItem(item) {
            this.selectedItem = item

            this.$emit('selectedItem', this.selectedItem)
        }
    },
    watch: {
        dataList: function(val) {
            //При асинхронной загрузке списка слежу за его обновлением
            this.list = [this.defaultItem]

            this.dataList.forEach(item => {
                this.list.push(item)
            })
        }
    }
}
</script>